import { ListItemText } from '@mui/material';
import { NavSubListItem } from '@procureai/ui-mui';
import { Link, useMatch } from 'react-router-dom';

import { RouteId } from '~/routes';

export interface CustomDataNavLinksItemProps {
  id: string;
  title: string;
}

export const CustomDataNavLinksItem = ({ id, title }: CustomDataNavLinksItemProps) => {
  const selected = !!useMatch({ path: `/:domain/${id}`, end: true });

  return (
    <NavSubListItem component={Link} to={`${RouteId.dataFoundation}/${id}`} selected={selected}>
      <ListItemText primary={title} />
    </NavSubListItem>
  );
};
